import { buildNewProfilesRequest } from '../../../../services/personApi';
import { cleanTaxId } from '../../../../utils/taxIdUtils';

export const COMPLETED_REGISTRATION_STATUS = 'COMPLETED';
export const SAVED_STATUS_NOT_COMPLETED_REASON = 'Disponível quando o Status de Cadastro salvo for Concluída.';
export const UNSAVED_CHANGES_REASON = 'Salve as alterações antes de notificar.';

export interface NotifyButtonState {
    enabled: boolean;
    reason: string;
}

export interface BasicDataForm {
    id: string;
    personId: string;
    govTaxId: string;
    legalName: string;
    fantasyName: string;
    zipcode: string;
    streetType: string;
    street: string;
    number: string;
    complement: string;
    district: string;
    cityId: string;
    registrationStatus?: string;
}

export interface BasicDataPayload {
    id: string;
    uuid: string;
    govTaxId: string;
    legalName: string;
    fantasyName: string;
    zipcode: string;
    streetType: string;
    street: string;
    number: string;
    complement: string;
    district: string;
    cityId: string;
    registrationStatus: string;
}

/**
 * Body of the PUT /legal-persons/{id} sent by "Atualizar" (and by "Salvar" of Aval. varejo).
 */
export const buildBasicDataPayload = (form: BasicDataForm): BasicDataPayload => ({
    id: form.id,
    uuid: form.personId,
    govTaxId: cleanTaxId(form.govTaxId),
    legalName: form.legalName,
    fantasyName: form.fantasyName,
    zipcode: form.zipcode.replace(/\D/g, ''),
    streetType: form.streetType || '',
    street: form.street || '',
    number: form.number || '',
    complement: form.complement || '',
    district: form.district || '',
    cityId: form.cityId?.toString() || '',
    registrationStatus: form.registrationStatus || 'IN_NEGOTIATION',
});

/**
 * True when the basic data differ from the last saved payload or a new profile is still pending.
 */
export const hasUnsavedChanges = (
    savedPayload: BasicDataPayload | null,
    form: BasicDataForm,
    profiles: string[],
    dbProfiles: string[],
): boolean =>
    JSON.stringify(buildBasicDataPayload(form)) !== JSON.stringify(savedPayload)
    || buildNewProfilesRequest(profiles, dbProfiles).profiles.length > 0;

/**
 * "Notificar cadastro atualizado" is enabled only for a saved COMPLETED status without unsaved changes.
 * The saved status decides the reason first (requirement 2.4).
 */
export const canNotifyRegistrationUpdated = (savedStatus: string | undefined, unsaved: boolean): NotifyButtonState => {
    if (savedStatus !== COMPLETED_REGISTRATION_STATUS) return { enabled: false, reason: SAVED_STATUS_NOT_COMPLETED_REASON };
    if (unsaved) return { enabled: false, reason: UNSAVED_CHANGES_REASON };
    return { enabled: true, reason: '' };
};
